/**
 * Alert <uo-tab-panel>
 *
 * Attributes:
 * id        The ID of the panel
 * active    Defines whether the tab is active or not
 */

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
export class AutomatorTabPanel extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// eslint-disable-next-line require-jsdoc
	static properties = {
		id: { type: String },
		active: { type: Boolean },
	};

	// eslint-disable-next-line require-jsdoc
	constructor() {
		super();
	}

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div 
				class="panel"
				?active=${ this.active }
			>
				<slot></slot>
			</div>
		`;
	}
}

customElements.define( 'uo-tab-panel', AutomatorTabPanel );
